module.exports = __webpack_public_path__ + "img/enter.ece89ed4.svg";